import { ReadingPaneDisplay } from './schema/PreviewPaneStore';
import { createStore } from 'satcheljs';
var initialPreviewPaneStore = {
    conversation: null,
    hideReadingPane: false,
    state: null,
    readingPaneSize: null,
    previewPaneSizePixels: 0,
    readingPaneSizePixels: 0,
    previewSelectionSource: null,
    pendingState: null,
    imageGallery: null,
    pendingNavigationAttachmentId: null,
    pendingNavigationTime: 0,
    readingPaneDisplay: ReadingPaneDisplay.Initial,
    haveSpaceForReadingPane: true,
};
export var getStore = createStore('previewpane', initialPreviewPaneStore);
export default getStore();
//# sourceMappingURL=Store.js.map